module.exports = __webpack_public_path__ + "img/A58A1898_min.2ca49494.jpg";